/**
 * Filtres d'image avancés pour le Pixel Art
 */

export const adjustImage = (data, settings) => {
  const { brightness, contrast, saturation, gamma } = settings;
  const factor = (259 * (contrast + 255)) / (255 * (259 - contrast));
  
  for (let i = 0; i < data.length; i += 4) {
    let r = data[i];
    let g = data[i+1];
    let b = data[i+2];

    // 1. Gamma
    if (gamma !== 1) {
      r = 255 * Math.pow(r / 255, 1 / gamma);
      g = 255 * Math.pow(g / 255, 1 / gamma);
      b = 255 * Math.pow(b / 255, 1 / gamma);
    }

    // 2. Luminosité & Contraste
    r = factor * (r + brightness - 128) + 128;
    g = factor * (g + brightness - 128) + 128;
    b = factor * (b + brightness - 128) + 128;

    // 3. Saturation (Conversion HSL simplifiée)
    if (saturation !== 1) {
      const gray = 0.2989 * r + 0.5870 * g + 0.1140 * b;
      r = gray + saturation * (r - gray);
      g = gray + saturation * (g - gray);
      b = gray + saturation * (b - gray);
    }

    data[i] = Math.min(255, Math.max(0, r));
    data[i+1] = Math.min(255, Math.max(0, g));
    data[i+2] = Math.min(255, Math.max(0, b));
  }
};